import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Container = styled.span.withConfig({
  displayName: "AIBadge__Container"
})(["display:inline-flex;align-items:center;justify-content:center;background:var(--trellis-color-breeze-fill-special-btn-alt-default);border-radius:", ";height:", ";width:", ";padding:", ";color:", ";font-size:10px;font-weight:", ";user-select:none;"], ({
  theme
}) => theme.borderRadius['200'], ({
  theme
}) => theme.space['500'], ({
  theme
}) => theme.space['800'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.color['text-primary-default'], ({
  theme
}) => theme.typography['body-100'].fontWeight);
const AIBadge = () => /*#__PURE__*/_jsx(Container, {
  children: "AI"
});
export default AIBadge;